module.exports = __webpack_public_path__ + "img/14.78df2d4a.jpg";